import { render } from "./PhotoUpload.vue?vue&type=template&id=7ccddc28&scoped=true"
import script from "./PhotoUpload.vue?vue&type=script&lang=js"
export * from "./PhotoUpload.vue?vue&type=script&lang=js"

import "./PhotoUpload.vue?vue&type=style&index=0&id=7ccddc28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ccddc28"]])

export default __exports__